import { Icon, Text, HStack, Stack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { Box, Pressable, useTheme } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { usePrivatePensionAssetContext } from '../../../../../contexts/products/PrivatePension';
import { LateralBar } from '../../../components/LateralBar';
import { privatePensionTableHead } from '../constants';
import { ListLoadingItemMobile } from '../ListLoadingItem/mobile';

import { MinimumApplicationTooltip } from './components/MinimumApplicationTooltip';

import { PrivatePensionItemTypes } from '.';

export const PrivatePensionItemMobile: React.FC<PrivatePensionItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePrivatePensionAssetContext();
  const { infoGetter, selectedTab, accountId } = useGlobalAssetContext();
  const theme = useTheme();

  const { Button, isSelected, forceLoading } = infoGetter(
    'privatePension',
    offer,
    'privatePensionId'
  );

  const onOpenDetailsModal = () => {
    if (!accountId) {
      return;
    }

    setModalOpen(true);
    setOfferSelected({ ...offer, accountId });
  };

  const middleInfos1 = [
    {
      label: privatePensionTableHead[1].title,
      value: <Text color="neutral.dark">{offer.managerNameNormalized}</Text>,
      w: '100%',
    },
  ];

  const middleInfos2 = [
    {
      label: privatePensionTableHead[4].title,
      value: <Text color="neutral.dark">{offer.annualRentabilityNormalized}</Text>,
      w: '33%',
    },
    {
      label: privatePensionTableHead[3].title,
      value: (
        <Box flexDirection="row" style={{ gap: Utils.Token.ToInt(theme.space, 'stack.quarck') }}>
          <MinimumApplicationTooltip
            minimumApplicationNormalized={offer.minimumApplicationNormalized}
            monthlyMinimumApplicationNormalized={offer.monthlyMinimumApplicationNormalized}
          />
          <Text color="neutral.dark">{offer.minimumApplicationNormalized}</Text>
        </Box>
      ),
      w: '33%',
    },
    {
      label: '',
      value: (
        <Stack alignSelf="flex-end">
          <Button
            id={selectedTab.typeGetterId}
            offer={offer}
            productContextConstant={selectedTab}
          />
        </Stack>
      ),
      w: '33%',
    },
  ];

  const infos = [middleInfos1, middleInfos2];

  if (forceLoading) {
    return <ListLoadingItemMobile />;
  }

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <HStack alignItems="center" space="inline.quarck">
          <Pressable onPress={onOpenDetailsModal}>
            <Icon name="Info" size="xs" />
          </Pressable>
          <Text variant="semibold" color="neutral.black" fontSize="lg">
            {offer.productNameNormalized}
          </Text>
        </HStack>
        {infos.map((info, i) => (
          <HStack justifyContent="space-between" key={`infos-${i}`}>
            {info.map(({ label, value, w }) => (
              <VStack w={w} space="stack.quarck" key={label}>
                {!!label && (
                  <Text color="neutral.black" variant="semibold">
                    {label}
                  </Text>
                )}
                {value}
              </VStack>
            ))}
          </HStack>
        ))}
      </VStack>
    </TableContent>
  );
};
